import { useEffect } from 'react';
import { CheckCircle2, CloudUpload, X } from 'lucide-react';
import { useTourPrepStore } from './tourPrepStore';
import { useDevStore } from '../../store/useDevStore';
import '../../components/help/help.css';

/**
 * Card sutil no topo: confirma envio ao servidor e que pode mudar de página.
 */
export function TourPrepBanner() {
  const { settings } = useDevStore();
  const banner = useTourPrepStore((s) => s.banner);
  const hideBanner = useTourPrepStore((s) => s.hideBanner);

  useEffect(() => {
    if (!settings.showTour || !banner.visible) return;
    const ms = banner.phase === 'sent' ? 7000 : 4500;
    const t = window.setTimeout(() => hideBanner(), ms);
    return () => window.clearTimeout(t);
  }, [settings.showTour, banner.visible, banner.phase, banner.path, hideBanner]);

  if (!settings.showTour || !banner.visible || !banner.phase) return null;

  const Icon = banner.phase === 'ready' ? CheckCircle2 : CloudUpload;

  return (
    <div
      className={`ac-tour-prep-banner ac-tour-prep-banner--${banner.phase}`}
      role="status"
      aria-live="polite"
    >
      <Icon size={16} className="ac-tour-prep-banner-icon" />
      <div className="ac-tour-prep-banner-text">
        <strong>
          {banner.phase === 'sent' ? 'Enviado ao servidor' : 'Tour pronto'}
        </strong>
        <span>{banner.message}</span>
      </div>
      <button
        type="button"
        className="ac-tour-prep-banner-close"
        onClick={hideBanner}
        aria-label="Fechar"
      >
        <X size={14} />
      </button>
    </div>
  );
}
